import React, { Component } from "react";
import { Navigate } from "react-router-dom";

export default class Main extends Component {
  render() {
    const cookie = window.localStorage.getItem("headersSetCookie");

    return cookie === null || cookie === "" ? (
      <Navigate to={"/login"} />
    ) : (
      <Navigate to={"/dashboard/"} />
    );
  }
}
